// AUTO-GENERATED by scripts/write-build-info.js at build time.
// Do not edit by hand — changes will be overwritten on the next build.
// Drives the BUILD chip rendered in the cockpit header so the
// Architect can verify, from any hardware, that the live page is the
// latest push. BUILD_STAMP_HUMAN is DD/MM HH:MM in Europe/London
// (BST during summer, GMT in winter — auto-detected at build time).

export const BUILD_SHA          = 'f1bc259';
export const BUILD_BRANCH       = 'main';
export const BUILD_TIME         = '2026-06-16T10:22:50.450Z';
export const BUILD_STAMP_HUMAN  = '16/06 11:22 BST';
